import React from 'react';

export const CurtainCentre = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 65.7" {...props}>
      <path fill="#fff" d="M4.9.8h86.3v61.1H4.9z" />
      <path
        d="M91.1 62.4H4.9c-.3 0-.5-.2-.5-.5V.8c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .2-.3.5-.6.5zM5.4 61.3h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.9.8h86.3v61.1H4.9z" />
      <path
        d="M91.1 62.4H4.9c-.3 0-.5-.2-.5-.5V.8c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .2-.3.5-.6.5zM5.4 61.3h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.9 4.8h78.2v53H8.9z" />
        <path d="M87.1 58.3H8.9c-.3 0-.5-.2-.5-.5v-53c0-.3.2-.5.5-.5h78.2c.3 0 .5.2.5.5v53c.1.3-.2.5-.5.5zm-77.7-1h77.1v-52H9.4v52z" />
      </g>
      <path
        d="M95.5 62.3H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h95c.3 0 .5.2.5.5s-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M.5.3h95v2.4H.5z" />
        <path d="M95.8 3H.2V0h95.6v3zm-95-.6h94.4V.6H.8v1.8z" fill="#fff" />
        <path
          fill="#233762"
          stroke="#fff"
          strokeWidth={0.557}
          strokeMiterlimit={10}
          d="M4.3 63.3V.3h34.2v63"
        />
        <path
          fill="#233762"
          stroke="#fff"
          strokeWidth={0.589}
          strokeMiterlimit={10}
          d="M12.9 63.3V7.4M21.4 63.3V7.4M29.9 63.3V7.4"
        />
        <path
          d="M4.3 63.1c2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2"
          fill="#233762"
        />
        <path
          d="M4.3 63.1c2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2 2.1 0 2.1 2.2 4.3 2.2 2.1 0 2.1-2.2 4.3-2.2"
          fill="none"
          stroke="#fff"
          strokeWidth={0.561}
          strokeMiterlimit={10}
        />
        <g>
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.575}
            strokeMiterlimit={10}
            d="M55.7 63.3V.3h36.4v63"
          />
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.609}
            strokeMiterlimit={10}
            d="M64.8 63.3V7.4M73.9 63.3V7.4M83 63.3V7.4"
          />
          <path
            d="M55.7 63c2.3 0 2.3 2.3 4.6 2.3s2.3-2.3 4.6-2.3 2.3 2.3 4.6 2.3 2.3-2.3 4.6-2.3 2.3 2.3 4.6 2.3S81 63 83.3 63s2.3 2.3 4.6 2.3 2.3-2.3 4.6-2.3"
            fill="#233762"
          />
          <path
            d="M55.7 63c2.3 0 2.3 2.3 4.6 2.3s2.3-2.3 4.6-2.3 2.3 2.3 4.6 2.3 2.3-2.3 4.6-2.3 2.3 2.3 4.6 2.3S81 63 83.3 63s2.3 2.3 4.6 2.3 2.3-2.3 4.6-2.3"
            fill="none"
            stroke="#fff"
            strokeWidth={0.58}
            strokeMiterlimit={10}
          />
        </g>
      </g>
    </svg>
  );
};
